
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import { AuthenticatedLayout } from "../../../layouts";
import { FilingResourceSetup } from "../../../components/FilingResource";

export const FilingResourceSetupPage = () => {
  return (
    <AuthenticatedLayout
      pageTitle="Filing Resource Setup"
      pageTitleIcon={<DescriptionOutlinedIcon />}
      breadcrumbCurrentPageName=""
      breadcrumbLinks={[
      { text: "Filing Resources", navigateTo: "/company/filing-resources/list" },
      { text: "Create Filing Resources", navigateTo: "/company/filing-resources/setup" }]}
      mainContents={<FilingResourceSetup testId="filing-resource-setup-page" />}
    />
  );
};
